import React from 'react';
import { FormularyCategory, ArticleParagraph, ArticleSection } from './article-shared';

const FORMULARY_CATEGORIES: { title: string; medications: string[] }[] = [
  {
    title: 'Antihistamines',
    medications: [ 'Banophen', 'Benztropine', 'Diphenhydramine/Benadryl', 'Hydroxyzine/Vistaril/Atarax' ],
  },
  {
    title: 'Antidepressants',
    medications: [
      'Amitriptyline',
      'Amoxapin/Asendin',
      'Bupropion-Dextromethorphan/Auvelity',
      'Buproprion/Wellbutrin',
      'Citalopram/Celexa',
      'Clomipramine/Anafranil',
      'Desipramine/Norpramin',
      'Duloxetine/Cymbalta',
      'Desvenlafaxine/Pristiq',
      'Doxepin',
      'Escitalopram/Lexapro',
      'Fluvoxamine/Luvox',
      'Fluoxetine/Prozac',
      'Imipramine/Tofranil',
      'Mirtazapine/Remeron',
      'Nortriptyline/Pamelor/Aventyl',
      'Paroxetine/Paxil',
      'Selegiline/Ensam',
      'Sertraline/Zoloft',
      'Trazodone/Desyrel',
      'Vortioxetine/Trintellix',
      'Venlafaxine/Effexor',
      'Vilazodone/Viibryd',
    ],
  },
  {
    title: 'Antipsychotics',
    medications: [
      'Aripiprazole/Abilify',
      'Abilify Maintena (Long Acting Injection)',
      'Brexpiprazole/Rexulti',
      'Cariprazine/Vraylar',
      'Geodon/Ziprasidone',
      'Haldol Decanoate (Long Acting Injection)',
      'Invega Sustenna (Long Acting Injection)',
      'Lurasidone/Latuda',
      'Olanzapine/Zyprexa',
      'Paliperidone/Invega',
      'Quetiapine/Seroquel',
      'Risperidone/Risperdal',
    ],
  },
  {
    title: 'Drug/Alcohol Cessation',
    medications: [ 'Disulfiram/Antabuse', 'Naltrexone/Vivitrol', 'Nicorette', 'Nicotine Patches', 'Varenicline/Chantix' ],
  },
  {
    title: 'Endocrine',
    medications: [ 'Liothyronine/Cytomel/triostate', 'Metformin' ],
  },
  {
    title: 'Erectile Dysfunction',
    medications: [ 'Sildenafil/Viagra', 'Tadalafil/Cialis' ],
  },
  {
    title: 'Non-Stimulant ADHD Medication',
    medications: [ 'Atomoxetine/Strattera', 'Clonidine/Kapvay', 'Guanfacine/Intuniv', 'Viloxazine/Qelbree' ],
  },
  {
    title: 'Mood Stabilizers',
    medications: [
      'Carbamazepine/Tegretol',
      'Lamotrigine/Lamictal',
      'Lithium',
      'Oxcarbazepine/Trileptal',
      'Topiramate/Topamax',
      'Valproate/Divalproex/Depakote',
    ],
  },
  {
    title: 'Nausea/Pain Medication',
    medications: [ 'Ibuprofen', 'Ondansetron/Zofran' ],
  },
  {
    title: 'Other Anxiety Medication',
    medications: [ 'Buspirone/Buspar', 'Gabapentin', 'Propranolol' ],
  },
  {
    title: 'Sleep Aids',
    medications: [ 'Melatonin', 'Prazosin/Minipress', 'Ramelteon/Rozerem' ],
  },
  {
    title: 'Vitamins',
    medications: [
      'B12 /Folate/Folic Acid',
      'Cholecalciferol/Ergocalciferol/Vit D/D3',
      'Multivitamin',
      'Prenatals',
      'Thiamine/Vitamin B1',
    ],
  },
];

export const FormularyArticle: React.FC = () => (
  <>
    <ArticleSection title="Approved Formulary">
      <ArticleParagraph>
        <strong>Corporation(s):</strong> Uplift Health Technologies, Inc., Uplift Behavioral Health, P.C., Uplift
        Behavioral Health NJ, P.C., Shine Medical Providers, P.C., Shine Medical of CA, P.C., Shine Medical of NJ,
        P.C., and Shine Medical, P.C., and BetterHelp, delivering care through the BetterHelp Telehealth
        Platforms
      </ArticleParagraph>
      <ArticleParagraph>
        <strong>Approval Date:</strong> 9/3/2025
      </ArticleParagraph>
      <ArticleParagraph>
        <strong>Approved By:</strong> Compliance Team
      </ArticleParagraph>
    </ArticleSection>

    {FORMULARY_CATEGORIES.map(category => (
      <FormularyCategory key={category.title} title={category.title} medications={category.medications} />
    ))}
  </>
);
